
import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { Interview } from "@/types/interview";
import { mockInterviews } from "@/data/interviews";
import { InterviewCard } from "@/components/interviews/InterviewCard";
import { InterviewHeader } from "@/components/interviews/InterviewHeader";
import { TooltipProvider } from "@/components/ui/tooltip";

const Interviews = () => {
  const { toast } = useToast();
  const [interviews, setInterviews] = useState<Interview[]>(mockInterviews);

  const handleAcceptInterview = (id: string) => {
    setInterviews(interviews.map(interview =>
      interview.id === id ? { ...interview, status: "accepted" } : interview
    ));
    toast({
      title: "Interview Accepted",
      description: "The interview has been confirmed. You'll receive a calendar invite shortly.",
      variant: "success",
    });
  };

  const handleCancelInterview = (id: string) => {
    setInterviews(interviews.map(interview =>
      interview.id === id ? { ...interview, status: "cancelled" } : interview
    ));
    toast({
      title: "Interview Cancelled",
      description: "The interview has been cancelled. The candidate will be notified.",
      variant: "destructive",
    });
  };

  const handleJoinMeeting = (interview: Interview) => {
    toast({
      title: "Joining Meeting",
      description: `Opening ${interview.platform} meeting room...`,
    });
  };

  const handleSyncCalendar = () => {
    toast({
      title: "Calendar Synced",
      description: "Your interview schedule has been synced with your calendar.",
      variant: "success",
    });
  };

  return (
    <TooltipProvider>
      <div className="container mx-auto py-8 px-4 md:px-6 space-y-8 animate-fade-in">
        <InterviewHeader onSyncCalendar={handleSyncCalendar} />

        <div className="grid gap-6">
          {interviews.map((interview) => (
            <InterviewCard 
              key={interview.id}
              interview={interview}
              onAccept={handleAcceptInterview}
              onCancel={handleCancelInterview}
              onJoin={handleJoinMeeting}
            />
          ))}
        </div>
      </div>
    </TooltipProvider>
  );
};

export default Interviews;
